import styled from 'styled-components';

export const BetweenDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
